import React from 'react'
import { withIdentity, WithIdentityProps } from '#src/containers/Identity'
import {
  RecommendExpert2Component,
  StartExpertConsumerConversationComponent
} from '#src/generated/graphql'
import ChatWidget from '#src/containers/ChatWidget'
import TeaserChatWidgetWithExpert from '#src/components/EngagementChannels/TeaserChatWidgetWithExpert'

interface CategoryChatWidgetProps {
  categoryId: string
  className?: string
  enableTeaserChat?: boolean
}

const CategoryChatWidget: React.SFC<CategoryChatWidgetProps & WithIdentityProps> = ({
  myself,
  categoryId,
  className,
  enableTeaserChat = false
}) => {
  if (process.env.TARGET === 'node') {
    return null
  }

  if (!myself) {
    if (!enableTeaserChat) {
      return null
    }

    return <TeaserChatWidgetWithExpert categoryId={categoryId} />
  }

  return (
    <RecommendExpert2Component variables={{ consumerId: myself.id, categoryId }}>
      {({ data }) => {
        if (!data || !data.recommendExpert2) {
          return null
        }

        // The recommended expert to talk to for this category
        const expert = data.recommendExpert2.expert

        if (!expert) {
          return null
        }

        // If you already have a lead with a conversation, we'll re-use that conversation
        const existingConversationId =
          data.recommendExpert2.expert &&
          data.recommendExpert2.expert.existingLeadForConsumer &&
          data.recommendExpert2.expert.existingLeadForConsumer.conversation &&
          data.recommendExpert2.expert.existingLeadForConsumer.conversation.externalId

        return (
          <StartExpertConsumerConversationComponent
            variables={{
              input: { consumerId: myself.id, expertId: expert.id }
            }}
          >
            {(startExpertCustomerConversation, { data }) => {
              // If you don't already have a conversation, we'll create one with `startExpertCustomerConversation`
              const newConversationId =
                data &&
                data.startExpertConsumerConversation.conversation &&
                data.startExpertConsumerConversation.conversation.externalId

              // Prefer the existing conversation (they should be the same)
              const conversationId = existingConversationId || newConversationId

              return (
                <ChatWidget
                  businessUserId={expert.id}
                  className={className}
                  conversationId={conversationId}
                  expert={expert}
                  onStartConversation={startExpertCustomerConversation}
                />
              )
            }}
          </StartExpertConsumerConversationComponent>
        )
      }}
    </RecommendExpert2Component>
  )
}

export default withIdentity(CategoryChatWidget)
